import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

const Home = lazy(() => import("../pages/HomePage"));
const ProductsPage = lazy(() => import("../pages/ProductsPage"));
const About = lazy(() => import("../pages/AboutPage"));
const BlogPage = lazy(() => import("../pages/BlogPage"));
const BlogDetailPage = lazy(() => import("../pages/BlogDetailPage"));
const Contact = lazy(() => import("../pages/ContactPage"));
const CareersPage = lazy(() => import("../pages/CareersPage"));
const FaqPage = lazy(() => import("../pages/FaqPage"));
const CartPage = lazy(() => import("../pages/CartPage"));
const CheckoutPage = lazy(() => import("../pages/CheckoutPage"));
const OrderSuccessPage = lazy(() => import("../pages/OrderSuccessPage"));
const DashboardPage = lazy(() => import("../pages/DashboardPage"));
const PrivacyPolicyPage = lazy(() => import("../pages/PrivacyPolicyPage"));
const TermsConditionsPage = lazy(() => import("../pages/TermsConditionsPage"));
const DataDeletionPage = lazy(() => import("../pages/DataDeletionPage"));
const RefundPolicyPage = lazy(() => import("../pages/RefundPolicyPage"));
const MaintenancePage = lazy(() => import("../pages/MaintenancePage"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));
const ServerErrorPage = lazy(() => import("../pages/ServerErrorPage"));

export default function AppRoutes() {
  return (
    <Suspense fallback={<div style={{ padding: "110px 20px", textAlign: "center" }}>Loading page...</div>}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-success" element={<OrderSuccessPage />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/data-deletion" element={<DataDeletionPage />} />
        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route path="/500" element={<ServerErrorPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}

